import { createQueryFactory } from "../query-factory";

export const { useApiHook: useGetFeatureFlags } = createQueryFactory("getFeatureFlags");
